<template>
  <div id="verify" class="mdl-grid">
    <div class="mdl-layout-spacer"></div>
    <div class="mdl-cell mdl-cell--4-col">
      <form v-on:submit.prevent="attemptVerification">
        <div class="mdl-card mdl-shadow--6dp">
          <div class="mdl-card__title mdl-color--primary mdl-color-text--white">
            <h2 class="mdl-card__title-text">Verify Account</h2>
          </div>
          <div class="mdl-card__supporting-text">
              <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label" v-mdl>
                <input class="mdl-textfield__input" type="text" id="email" v-model="user"/>
                <label class="mdl-textfield__label" for="email">Email</label>
              </div>
              <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label" v-mdl>
                <input class="mdl-textfield__input" type="text" id="vcode" v-model="verification"/>
                <label class="mdl-textfield__label" for="vcode">Verification Code</label>
              </div>
          </div>
          <div class="mdl-card__actions mdl-card--border">
            <button class="mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect" type="submit" v-mdl>Verify Account</button>
          </div>
        </div>
      </form>
    </div>
    <div class="mdl-layout-spacer"></div>
  </div>
</template>

<script>
export default {
  name: 'VerifyAccount',
  data: function () {
    return {
      user: '',
      verification: ''
    }
  },
  methods: {
    attemptVerification: async function () {
      try {
        await this.$store.dispatch('verify', {
          user: this.user,
          code: this.verification
        })
        this.$router.push('/')
      } catch (e) {
        alert('Invalid verification code!')
      }
    }
  },
  mounted () {
    this.user = this.$store.state.newUser || ''
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/VerifyAccount.vue